export default "__VITE_ASSET__CEAp54Wd__"